import { Record } from 'immutable';
import type ErrorRecord from '~/data/ErrorRecord';
import FleetAccountRecord from './FleetAccountRecord';
import SubscriptionAccountRecord from './SubscriptionAccountRecord';

const keys: Fields = {
  isLoading: true,
  isSubmitting: false,
  isSubmitted: false,
  fleetAccount: new FleetAccountRecord(),
  subscriptionAccount: new SubscriptionAccountRecord(),
  showSubscriptionAccount: false,
  loadError: undefined,
  submitError: undefined,
};

interface Fields {
  isLoading: boolean;
  isSubmitting: boolean;
  isSubmitted: boolean;
  fleetAccount: FleetAccountRecord;
  subscriptionAccount: SubscriptionAccountRecord;
  showSubscriptionAccount: boolean;
  loadError?: ErrorRecord;
  submitError?: ErrorRecord;
}

export default class CompanyAccountSettingsRecord extends Record<Fields>(keys) {
  constructor(values?) {
    super(values);
    return this.merge(values);
  }

  setLoading(isLoading) {
    return this.set('isLoading', isLoading);
  }

  setFleetAccount(fleetAccount) {
    return this.update('fleetAccount', (fa) => fa.merge(fleetAccount));
  }

  setSubscriptionAccount(subscriptionAccount) {
    return this.update('subscriptionAccount', (sa) => sa.merge(subscriptionAccount));
  }
}
